<template>
  <div class="life2">
    <div>
      龍崎，顧名思義，是一處幾乎地無三里平的地區，雖然龍崎區名的由來並非直接由惡地地形而來，但是，奇峻的地勢，加上開墾甚早，讓龍崎區這塊土地，不但擁有豐富的名勝景觀，還有許多傳統民俗文化遺產，雖然龍崎區的人口近年來已漸流失，但是深植在龍崎的多樣化資產，卻是龍崎最引人入勝的財富，值得細細咀嚼、品嚐。
    </div>
    <div>&nbsp;</div>
    <div>
      龍崎區舊稱「番社」，係因早期平埔族西拉雅族新港社人遷居本區大坪、牛埔一帶而得名。清領時期屬臺灣縣新豐里，道光年間改隸「內新豐里」。日治時期前期內新豐里為臺南廳關帝廟支聽內新豐區管理，直到1920年臺灣地方改制，取較大聚落龍船及崎頂之字，設置龍崎庄，隸屬台南州新豐郡。龍崎庄役場位於番社(佇大坪村)，1926年5月8日遷至崎頂。戰後改設臺南縣龍崎鄉，2010年12月25日改稱龍崎區。
    </div>
    <div>&nbsp;</div>
    <div>&nbsp;</div>
    <div>
      <img src="~@/assets/images/life-page1-img-1.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Life2',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped>
.life2 img {
  width: 100%;
}
</style>
